<template>
  <div >
    <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-if='!matched'
      ></v-text-field>
    <v-data-table
        ref="dTable"
        :headers="headers"
        :items="transactions"
        class="datatable"
        disable-initial-sort
        :pagination.sync="pagination"
        :rows-per-page-items='[15, 30, 50, 100]'
        must_sort
        :expand="true"
        :search="search"
        item-key="transaction_id"
      >
      <template v-slot:items="props">
        <tr @click="props.expanded = !props.expanded" :key="props.item.transaction_id">
          <td class="text-xs-left body-small">{{ props.item.name }}</td>
          <td class="text-xs-left body-small">{{ props.item.amount | toCurrency(lang, currCode) }}</td>
          <td class="text-xs-left body-small">{{ formatDate(props.item.date) }} </td>
          <td class="text-xs-right body-small">
            <v-btn class="dark-text" fab flat medium>
              <v-icon>arrow_drop_down</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <template v-slot:expand="props">
        <bank-match-invoice :transaction="props.item" ></bank-match-invoice>
      </template>
      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        From {{ pageStart }} to {{ pageStop }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import BankMatchInvoice from '@/components/Shared/BankMatchInvoice'
import { formatDate } from '@/components/Mixins/formatDate'

export default {
  props: {
    transactions: {
      type: Array
    },
    matched: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BankMatchInvoice
  },
  mixins: [formatDate],
  data () {
    return {
      search: '',
      expand: false,
      pagination: {
        rowsPerPage: 15,
        sortBy: 'date',
        descending: true
      },
      headers: [
        { text: 'Name', value: 'name', align: 'left', class: 'body-2 font-weight-bold' },
        { text: 'Amount', value: 'amount', align: 'left', class: 'body-2 font-weight-bold' },
        { text: 'Date', value: 'date', align: 'left', class: 'body-2 font-weight-bold' },
        { text: '', value: 'opened', align: 'left', class: 'body-2 font-weight-bold' }
      ],
      lang: this.$store.getters.group.lang,
      currCode: this.$store.getters.group.currCode,
      currSymbol: this.$store.getters.group.currSymbol
    }
  },
  mounted () {
    // hacky way of expanding all rows when it's in matching mode
    this.transactions.forEach((transaction) => {
      if (transaction.matchedInvoices) {
        this.$set(this.$refs.dTable.expanded, transaction.transaction_id, true)
      }
    })
  }
}
</script>
